import { __assign } from "tslib";
/**
 * Calculate how much font-size should
 * be scaled down to prevent overflow.
 */
var calculateOverflowFreeScale = function (element, restStateStyles) {
    var ruler = element.cloneNode(true);
    ruler.id = Math.random()
        .toString(36)
        .substring(7);
    var parent = element.parentElement || document.body;
    css(ruler, __assign(__assign({}, restStateStyles), { display: 'block', opacity: 0, overflow: 'hidden', transform: '' }));
    parent.appendChild(ruler);
    var scale = findScale(ruler, 1, restStateStyles.fontSize || '2vw');
    parent.removeChild(ruler);
    return scale;
};
export default calculateOverflowFreeScale;
/**
 * Scale font-size by 10% until there is no overflow.
 */
var findScale = function (element, currentScale, originalFontSize) {
    if (currentScale === void 0) { currentScale = 1; }
    if (!hasOverflow(element)) {
        return currentScale;
    }
    var scale = currentScale * 0.9;
    var fontSize = parseFloat(originalFontSize) * scale + "vw";
    css(element, { fontSize: fontSize });
    return findScale(element, scale, originalFontSize);
};
/**
 * Apply an object of CSS properties to a HTML Element.
 */
var css = function (el, styles) {
    for (var property in styles) {
        if (Object.prototype.hasOwnProperty.call(styles, property)) {
            el.style[property] = styles[property];
        }
    }
};
var OVERFLOW_TOLERANCE = 1;
/**
 * Detect if an HTML Element has overflow.
 *
 * I HATE INTERNET EXPLORER.
 *
 * Because our measurements are based on percentages, they may be fractions
 * of a pixel and get rounded. IE may round scrollWidth & scrollHeight *up*,
 * while rounding clientWidth and clientHeight *down*, meaning the scroll
 * measurements will always be larger than the client measurements. So we
 * subtract a pixel from the scroll measurements to avoid this.
 */
var hasOverflow = function (element) {
    return element.scrollWidth - OVERFLOW_TOLERANCE > element.clientWidth ||
        element.scrollHeight - OVERFLOW_TOLERANCE > element.clientHeight;
};
